import React from 'react';
import { useTranslation } from "react-i18next";

import { ReactComponent as InfoIcon } from 'assets/icons/ico_info_circle_blue.svg';
import CommunityMemberItem from './communityMemberItem';

const CommunityMembersTable = ({ communityMembers, setCommunityMembers }) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="-mr-6 -ml-6 airpark-scroll overflow-x-scroll">
                <table className="table-auto w-full">
                    <thead className=''>
                        <tr className="text-left bg-airpark-gray-300 h-11">
                            <th className="pl-6 whitespace-nowrap">{t('communityMembersTable.firstName')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('communityMembersTable.lastName')}</th>
                            <th className="pl-6 whitespace-nowrap">{t('communityMembersTable.phoneNumber')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {communityMembers && communityMembers.length > 0 && communityMembers.map((communityMember, i) => {
                            return (<CommunityMemberItem 
                                        key={i} 
                                        communityMember={communityMember} 
                                        communityMembers={communityMembers} 
                                        setCommunityMembers={setCommunityMembers} />)
                        })}
                        {communityMembers && communityMembers.length < 1 &&
                            <tr className="h-16">
                                <td className="text-center" colSpan={4}>
                                    <div className="flex pl-6 gap-3 flex-row items-center justify-left">
                                        <InfoIcon className="h-6 w-6" />
                                        <span>{t('communityMembersTable.noMembers')}</span>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default CommunityMembersTable;